const ApplePayButtonStatusConstant = {
    UNKNOWN: 0,
    AVAILABLE: 1,
    NOT_AVAILABLE: 2,
};
export default ApplePayButtonStatusConstant;